import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../../../services/shared.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'quotation-dialog',
    templateUrl: 'quotation-dialog.html',
    styleUrls: ['quotation-dialog.scss']
})
// tslint:disable-next-line:component-class-suffix
export class QuotationDialog implements OnInit {
    result: any = [];


    constructor(
        public shareService:SharedService,
        public dialogRef: MatDialogRef<QuotationDialog>,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (this._data != null) {
            this.result = this._data;
        }
    }


    ngOnInit() {
    }

    mailTo(email: any) {
        window.location.href = `mailto:${email}`;
    }

    callTo(number: string) {
        let contactNo = number.replace(/\D/g, "");
        window.location.href = `tel:${contactNo}`;
    }


    downloadQuotation(url: string) {
        window.open(url);
    }
}
